import { useLayoutEffect, useState } from "react";
import { displayMessage, getAPI, postAPI } from "../../../utils/common";
import { ReloadOutlined, EyeOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Layout,
  Table,
  Input,
  Spin,
  Modal,
  Descriptions,
  Tag,
  Select,
  DatePicker,
  Popconfirm,
} from "antd";
import {
  ALL_VENDOR_BILLS,
  BILL_ACTION_DISCOUNT,
  BILL_INVOICE,
  BILL_RAISE_DISCOUNT,
  BILL_RAZORPAY_LINK_GEN,
  BILL_TRANS_CREATE,
  CANCEL_VENDOR_BILL,
  RAZORPAY_ORDER_CREATE,
  RAZORPAY_VERIFY,
  SETTING,
  VENDOR_BILL_DISCOUNT_LOGS,
} from "../../../constants/api";
import dayjs from "dayjs";
import { ERROR_MSG_TYPE } from "../../../constants/messages";
import { Timeline } from "antd";
import {
  CURRENCY,
  getHotelType,
  HOTEL_ID_SERIES,
  isVendor,
} from "../../../constants/constent";
import VendorDetailCard from "../blocs/VendorDetailCard";

function VendorBills() {
  const { Content } = Layout;
  const { vendor_id } = useParams();
  const [state, setState] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buttonloading, setButtonLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [billType, setBillType] = useState("");
  const [billStatus, setBillStatus] = useState("");
  const [billDate, setBillDate] = useState(null);

  // Modal state
  const [discountModalVisible, setDiscountModalVisible] = useState(false);
  const [discountCode, setDiscountCode] = useState("");
  const [discountRemark, setDiscountRemark] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);

  const [txnModalVisible, setTxnModalVisible] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);

  const [, setSetting] = useState(null);
  const [codEnabled, setCodEnabled] = useState(0);
  const [onlineEnabled, setOnlineEnabled] = useState(0);

  const [discountLogs, setDiscountLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  const [cancelRemark, setCancelRemark] = useState("");

  const navigate = useNavigate();

  /* ================= FETCH LIST ================= */
  useLayoutEffect(() => {
    getList();
    getSetting();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendor_id]);

  const getList = () => {
    setLoading(true);
    const payload = {};

    if (vendor_id) payload.vendor_id = vendor_id;
    if (billType) payload.bill_type = billType;
    if (billStatus) payload.bill_status = billStatus;
    if (billDate) payload.bill_gen_date = dayjs(billDate).format("YYYY-MM-DD");

    postAPI(
      ALL_VENDOR_BILLS,
      payload,
      (res) => {
        if (res.status) {
          const rows = res.data.map((row, index) => ({
            key: row.id,
            id: index + 1,
            ...row,
            hotel_id: HOTEL_ID_SERIES + row.vendor.hotel_id,
          }));
          setState(rows);
          setFilteredData(rows);
        }
        setLoading(false);
      },
      () => setLoading(false),
    );
  };

  const getDiscountLogs = (billId) => {
    setLogsLoading(true);

    postAPI(
      VENDOR_BILL_DISCOUNT_LOGS,
      { bill_id: billId },
      (res) => {
        if (res.status) {
          setDiscountLogs(res.data);
        }
        setLogsLoading(false);
      },
      () => setLogsLoading(false),
    );
  };

  const getSetting = () => {
    getAPI(SETTING, handleSettingSuccess, handleSettingError);
  };

  const handleSettingSuccess = (data) => {
    if (data.status) {
      setSetting(data.data);
      setCodEnabled(data?.data?.cod_accept ?? 0);
      setOnlineEnabled(data?.data?.online_accept ?? 0);
    } else {
      displayMessage(ERROR_MSG_TYPE, data.message);
    }
  };

  const handleSettingError = () => {
    displayMessage(ERROR_MSG_TYPE, "Unable to Get Setting");
  };

  const handleCashPayment = (bill) => {
    setButtonLoading(true);
    postAPI(
      BILL_TRANS_CREATE,
      {
        vendor_id: bill.vendor_id,
        vendor_bill_id: bill.key,
        payment_method: "cash",
        payment_status: "paid",
        remark: "Cash payment",
      },
      (res) => {
        setButtonLoading(false);
        if (res.status) {
          closeModal();
          getList();
        }
      },
      () => {
        setButtonLoading(false);
      },
    );
  };

  const handleRazorpayPayment = (bill) => {
    setButtonLoading(true);
    postAPI(
      RAZORPAY_ORDER_CREATE,
      {
        vendor_id: bill.vendor_id,
        vendor_bill_id: bill.key,
        amount: bill.total_rest_amount,
      },
      (res) => {
        setButtonLoading(false);
        if (!res.status) return;

        const options = {
          key: res.key,
          amount: res.amount,
          currency: "INR",
          order_id: res.order_id,
          name: "Vendor Bill Payment",
          description: bill.bill_no,

          handler: function (response) {
            verifyRazorpayPayment(bill, response);
          },

          prefill: {
            name: bill.vendor.vendor_name,
            email: bill.vendor.hotel_email_id,
            contact: bill.vendor.hotel_whatsapp_no,
          },

          theme: {
            color: "#1677ff",
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      },
      () => {
        setButtonLoading(false);
      },
    );
  };

  const verifyRazorpayPayment = (bill, razorpayRes) => {
    setButtonLoading(true);
    postAPI(
      RAZORPAY_VERIFY,
      {
        vendor_id: bill.vendor_id,
        vendor_bill_id: bill.key,
        amount: bill.total_rest_amount,
        razorpay_order_id: razorpayRes.razorpay_order_id,
        razorpay_payment_id: razorpayRes.razorpay_payment_id,
        razorpay_signature: razorpayRes.razorpay_signature,
      },
      (res) => {
        setButtonLoading(false);
        if (res.status) {
          closeModal();
          getList();
        }
      },
      () => {
        setButtonLoading(false);
      },
    );
  };

  const handleGeneratePaymentLink = (bill) => {
    setButtonLoading(true);
    postAPI(
      BILL_RAZORPAY_LINK_GEN,
      {
        vendor_id: bill.vendor_id,
        vendor_bill_id: bill.key,
        amount: bill.total_rest_amount,
      },
      (res) => {
        if (res.status) {
          setButtonLoading(false);
          Modal.success({
            title: "Payment Link Generated",
            content: (
              <>
                <p>Link sent via SMS / Email</p>
                <a
                  href={res.data.payment_link}
                  target="_blank"
                  rel="noreferrer"
                >
                  Open Payment Link
                </a>
              </>
            ),
          });
          getList();
        } else {
          setButtonLoading(false);
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setButtonLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Fail to generate the payment link");
      },
    );
  };

  // Bill Discount

  const handleRaiseDiscount = () => {
    if (!discountCode) {
      displayMessage(ERROR_MSG_TYPE, "Please enter discount code");
      return;
    }
    setButtonLoading(true);

    postAPI(
      BILL_RAISE_DISCOUNT,
      {
        bill_id: selectedBill.key,
        discount_code: discountCode,
        remark: discountRemark,
      },
      (res) => {
        if (res.status) {
          setButtonLoading(false);
          displayMessage("success", res.message);
          setDiscountModalVisible(false);
          setDiscountCode("");
          setDiscountRemark("");
          getList();

          // 🔥 1️⃣ Update table list real-time
          setState((prev) =>
            prev.map((item) =>
              item.key === selectedBill.key ? { ...item, ...res.data } : item,
            ),
          );

          // 🔥 2️⃣ Update filtered list also (important)
          setFilteredData((prev) =>
            prev.map((item) =>
              item.key === selectedBill.key ? { ...item, ...res.data } : item,
            ),
          );

          // 🔥 3️⃣ Update currently opened modal data
          setSelectedBill((prev) => ({
            ...prev,
            ...res.data,
          }));

          // 🔥 4️⃣ Refresh logs only
          getDiscountLogs(selectedBill.key);
        } else {
          setButtonLoading(false);
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setButtonLoading(false);
      },
    );
  };

  const handleDiscountAction = (action, remark = "") => {
    setButtonLoading(true);
    postAPI(
      BILL_ACTION_DISCOUNT,
      {
        bill_id: selectedBill.key,
        action,
        remark,
      },
      (res) => {
        if (res.status) {
          setButtonLoading(false);
          displayMessage("success", res.message);
          // 🔥 1️⃣ Update table list real-time
          setState((prev) =>
            prev.map((item) =>
              item.key === selectedBill.key ? { ...item, ...res.data } : item,
            ),
          );

          // 🔥 2️⃣ Update filtered list also (important)
          setFilteredData((prev) =>
            prev.map((item) =>
              item.key === selectedBill.key ? { ...item, ...res.data } : item,
            ),
          );

          // 🔥 3️⃣ Update currently opened modal data
          setSelectedBill((prev) => ({
            ...prev,
            ...res.data,
          }));

          // 🔥 4️⃣ Refresh logs only
          getDiscountLogs(selectedBill.key);
        } else {
          setButtonLoading(false);
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setButtonLoading(false);
      },
    );
  };

  const handleCancelBill = (record) => {
    setButtonLoading(true);
    postAPI(
      CANCEL_VENDOR_BILL,
      { bill_id: record.key, remark: cancelRemark },
      (res) => {
        setButtonLoading(false);
        if (res.status) {
          displayMessage("success", res.message);
          setCancelRemark("");
          getList();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setButtonLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to cancel the bill");
      },
    );
  };

  /* ================= SEARCH ================= */
  const handleSearch = (value) => {
    const search = value.toLowerCase().trim();
    setSearchText(value);
    if (!search) {
      setFilteredData(state);
      return;
    }
    setFilteredData(
      state.filter((item) =>
        Object.values(item).some(
          (val) =>
            typeof val === "string" && val.toLowerCase().includes(search),
        ),
      ),
    );
  };

  /* ================= MODAL HANDLER ================= */
  const showDetails = (bill) => {
    setSelectedBill(bill);
    setModalVisible(true);
    getDiscountLogs(bill.key);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedBill(null);
  };

  const showTransactions = (bill) => {
    setSelectedTransactions(bill.transactions || []);
    setTxnModalVisible(true);
  };

  const closeTxnModal = () => {
    setTxnModalVisible(false);
    setSelectedTransactions([]);
  };

  /* ================= STATUS TAG ================= */
  const renderBillStatusTag = (status) => {
    let color = "default";
    if (status === "paid") color = "green";
    else if (status === "partial") color = "orange";
    else if (status === "pending") color = "blue";
    else if (status === "cancelled") color = "red";

    return <Tag color={color}>{(status || "").toUpperCase()}</Tag>;
  };

  /* ================= TABLE ================= */
  const columns = [
    { title: "S. No.", dataIndex: "id" },
    !isVendor() && { title: "Hotel ID", dataIndex: "hotel_id" },
    !isVendor() && {
      title: "Hotel Name",
      dataIndex: ["vendor", "hotel_name"],
      render: (_, row) => row.vendor.hotel_name,
    },
    // {
    //   title: "Hotel Type",
    //   dataIndex: ["vendor", "hotel_type"],
    //   render: (_, row) => row.vendor.hotel_type,
    // },
    // {
    //   title: "Vendor Name",
    //   dataIndex: ["vendor", "vendor_name"],
    //   render: (_, row) => row.vendor.vendor_name,
    // },
    {
      title: "Bill Date",
      dataIndex: "bill_gen_date",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY hh:mm A") : "-"), // includes time
    },
    { title: "Bill No", dataIndex: "bill_no" },
    { title: "Invoice No", dataIndex: "invoice_no" },
    {
      title: "Bill Type",
      dataIndex: "bill_type",
      render: (type) => type.toUpperCase(),
    },
    {
      title: "Amount",
      dataIndex: "bill_amount",
      render: (amount) => `${CURRENCY}${amount}`,
    },
    {
      title: "Status",
      dataIndex: "bill_status",
      render: (bill_status) => renderBillStatusTag(bill_status),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          {record.bill_status === "paid" && (
            <Button
              onClick={() => {
                const id = record.id;
                const encodedId = btoa(id.toString());
                const url = `${BILL_INVOICE}${encodedId}`;
                window.open(url, "_blank");
              }}
              loading={loading}
              disabled={loading}
              block
            >
              INVOICE
            </Button>
          )}
          <Button icon={<EyeOutlined />} onClick={() => showDetails(record)}>
            View Details
          </Button>

          <Button type="primary" ghost onClick={() => showTransactions(record)}>
            View Transactions
          </Button>

          {!isVendor() &&
            (record.bill_status === "pending" ||
              record.bill_status === "partial") && (
              <Popconfirm
                title="Cancel this bill"
                description={
                  <Input.TextArea
                    placeholder="Cancellation remark (optional)"
                    style={{ width: 250 }}
                    onChange={(e) => setCancelRemark(e.target.value)}
                  />
                }
                okText="Cancel Bill"
                okButtonProps={{ danger: true }}
                cancelText="Close"
                onConfirm={() => handleCancelBill(record)}
                onCancel={() => setCancelRemark("")}
              >
                <Button danger loading={buttonloading}>
                  Cancel Bill
                </Button>
              </Popconfirm>
            )}
        </Space>
      ),
    },
  ].filter(Boolean);

  const txnColumns = [
    { title: "ID", dataIndex: "id" },
    { title: "Method", dataIndex: "payment_method" },
    { title: "Amount", dataIndex: "payment_amount" },
    {
      title: "Status",
      dataIndex: "payment_status",
      render: (status) => {
        let color = "default";
        if (status === "paid") color = "green";
        if (status === "pending") color = "orange";
        if (status === "failed") color = "red";

        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      },
    },

    {
      title: "Payment Date",
      dataIndex: "payment_date",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY hh:mm A") : "-"),
    },
    {
      title: "Payment Link",
      dataIndex: "payment_link",
      render: (link) =>
        link ? (
          <a href={link} target="_blank" rel="noreferrer">
            Open Link
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: "PG Transaction ID",
      dataIndex: "pg_transaction_id",
      render: (val) => val || "-",
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title={"Manage Bills"}
          extra={
            <Space wrap>
              <Input
                placeholder="Search bills..."
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
              />

              <Select
                placeholder="Bill Type"
                allowClear
                style={{ width: 150 }}
                value={billType}
                onChange={(val) => setBillType(val)}
              >
                <Select.Option value="subscription">Subscription</Select.Option>
                <Select.Option value="setup">Setup</Select.Option>
              </Select>

              <Select
                placeholder="Bill Status"
                allowClear
                style={{ width: 150 }}
                value={billStatus}
                onChange={(val) => setBillStatus(val)}
              >
                <Select.Option value="pending">Pending</Select.Option>
                <Select.Option value="partial">Partial</Select.Option>
                <Select.Option value="paid">Paid</Select.Option>
                <Select.Option value="cancelled">Cancelled</Select.Option>
              </Select>

              <DatePicker
                placeholder="Bill Date"
                value={billDate}
                onChange={(date) => setBillDate(date)}
              />

              <Button type="primary" onClick={getList}>
                Apply Filters
              </Button>

              <Button
                onClick={() => {
                  setBillType("");
                  setBillStatus("");
                  setBillDate(null);
                  getList();
                }}
              >
                Clear Filters
              </Button>
              <Button ghost type="primary" loading={loading} onClick={getList}>
                <ReloadOutlined />
              </Button>

              {vendor_id && !isVendor() ? (
                <Button onClick={() => navigate(-1)}>Go Back</Button>
              ) : null}
            </Space>
          }
        >
          <Spin spinning={loading}>
            {vendor_id && state[0]?.vendor && (
              <div style={{ marginBottom: 16 }}>
                <VendorDetailCard vendor={state[0].vendor} />
              </div>
            )}
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 1000 }}
            />
          </Spin>
        </Card>
      </Content>

      {/* ================= MODAL ================= */}
      <Modal
        title="Bill Details"
        open={modalVisible}
        onCancel={closeModal}
        width="90%"
        style={{ maxWidth: 900 }}
        footer={[
          <Button
            key="close"
            onClick={closeModal}
            loading={buttonloading}
            disabled={buttonloading}
          >
            Close
          </Button>,

          !isVendor() &&
            codEnabled === 1 &&
            selectedBill?.total_rest_amount > 0 && (
              <Button
                key="cash"
                loading={buttonloading}
                disabled={buttonloading}
                onClick={() => handleCashPayment(selectedBill)}
              >
                Pay Cash
              </Button>
            ),

          onlineEnabled === 1 && selectedBill?.total_rest_amount > 0 && (
            <Button
              key="razorpay"
              type="primary"
              loading={buttonloading}
              disabled={buttonloading}
              onClick={() => handleRazorpayPayment(selectedBill)}
            >
              Pay via Razorpay
            </Button>
          ),

          onlineEnabled === 1 && selectedBill?.total_rest_amount > 0 && (
            <Button
              key="link"
              loading={buttonloading}
              disabled={buttonloading}
              onClick={() => handleGeneratePaymentLink(selectedBill)}
            >
              Generate Payment Link
            </Button>
          ),

          !isVendor() && selectedBill && (
            <>
              {selectedBill.total_rest_amount > 0 &&
                selectedBill.discount_approved === null && (
                  <Button
                    key="raise"
                    type="dashed"
                    loading={buttonloading}
                    disabled={buttonloading}
                    onClick={() => setDiscountModalVisible(true)}
                  >
                    Raise Discount
                  </Button>
                )}

              {selectedBill.discount_approved === false && (
                <>
                  <Button
                    key="approve"
                    type="primary"
                    style={{ backgroundColor: "green" }}
                    loading={buttonloading}
                    disabled={buttonloading}
                    onClick={() => handleDiscountAction("approve")}
                  >
                    Approve Discount
                  </Button>

                  <Button
                    key="reject"
                    danger
                    loading={buttonloading}
                    disabled={buttonloading}
                    onClick={() => setRejectModalVisible(true)}
                  >
                    Reject Discount
                  </Button>
                </>
              )}
            </>
          ),
        ]}
      >
        {selectedBill && (
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {/* ================= BILL INFO ================= */}
            <Card size="small" title="Bill Information">
              <Descriptions
                column={{ xs: 1, sm: 1, md: 2, lg: 2 }}
                size="small"
                layout="vertical"
              >
                <Descriptions.Item label="Invoice No">
                  {selectedBill.invoice_no}
                </Descriptions.Item>
                <Descriptions.Item label="Bill No">
                  {selectedBill.bill_no}
                </Descriptions.Item>
                <Descriptions.Item label="Bill Type">
                  {selectedBill.bill_type.toUpperCase()}
                </Descriptions.Item>
                <Descriptions.Item label="Bill Status">
                  {renderBillStatusTag(selectedBill.bill_status)}
                </Descriptions.Item>
                <Descriptions.Item label="Bill Date">
                  {dayjs(selectedBill.bill_gen_date).format(
                    "DD-MM-YYYY hh:mm A",
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Total Days">
                  {selectedBill.total_days || "-"}
                </Descriptions.Item>
              </Descriptions>
            </Card>

            {/* ================= FINANCIAL INFO ================= */}
            <Card size="small" title="Financial Details">
              <Descriptions
                column={{ xs: 1, sm: 1, md: 2, lg: 3 }}
                size="small"
                layout="vertical"
              >
                <Descriptions.Item label="Total Amount">
                  {CURRENCY}{" "}
                  {parseFloat(selectedBill.total_amount || 0).toFixed(2)}
                </Descriptions.Item>
                <Descriptions.Item label="Discount">
                  {CURRENCY}{" "}
                  {parseFloat(selectedBill.discount_amount || 0).toFixed(2)}
                </Descriptions.Item>
                <Descriptions.Item label="Tax">
                  {CURRENCY}{" "}
                  {parseFloat(selectedBill.tax_value || 0).toFixed(2)} (
                  {selectedBill.tax_rate}%)
                </Descriptions.Item>
                <Descriptions.Item label="Sub Total">
                  {CURRENCY}{" "}
                  {parseFloat(selectedBill.sub_total_amount || 0).toFixed(2)}
                </Descriptions.Item>
                <Descriptions.Item label="Bill Amount">
                  {CURRENCY}{" "}
                  {parseFloat(selectedBill.bill_amount || 0).toFixed(2)}
                </Descriptions.Item>
                <Descriptions.Item label="Remaining">
                  <Tag color="red">
                    {CURRENCY}{" "}
                    {parseFloat(selectedBill.total_rest_amount || 0).toFixed(2)}
                  </Tag>
                </Descriptions.Item>
              </Descriptions>
            </Card>

            {/* ================= VENDOR INFO ================= */}
            <Card size="small" title="Vendor Details">
              <Descriptions
                column={{ xs: 1, sm: 1, md: 2 }}
                size="small"
                layout="vertical"
              >
                <Descriptions.Item label="Hotel ID">
                  {HOTEL_ID_SERIES + selectedBill.vendor.hotel_id}
                </Descriptions.Item>
                <Descriptions.Item label="Vendor">
                  {selectedBill.vendor.vendor_name}
                </Descriptions.Item>
                <Descriptions.Item label="Hotel">
                  {selectedBill.vendor.hotel_name}
                </Descriptions.Item>
                <Descriptions.Item label="Type">
                  {getHotelType(selectedBill.vendor.hotel_type)}
                </Descriptions.Item>
                <Descriptions.Item label="Email">
                  {selectedBill.vendor.hotel_email_id}
                </Descriptions.Item>
                <Descriptions.Item label="WhatsApp">
                  {selectedBill.vendor.hotel_whatsapp_no}
                </Descriptions.Item>
              </Descriptions>
            </Card>

            {/* ================= DISCOUNT INFO ================= */}
            <Card size="small" title="Discount Details">
              <Descriptions
                column={{ xs: 1, sm: 1, md: 2 }}
                size="small"
                layout="vertical"
              >
                <Descriptions.Item label="Discount Code">
                  {selectedBill.discount_code || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  {selectedBill.discount_approved === true && (
                    <Tag color="green">Approved</Tag>
                  )}
                  {selectedBill.discount_approved === false && (
                    <Tag color="orange">Pending Approval</Tag>
                  )}
                  {(selectedBill.discount_approved === null ||
                    selectedBill.discount_approved === undefined) && (
                    <Tag>Not Applied</Tag>
                  )}
                </Descriptions.Item>
                {/* <Descriptions.Item label="Apply By">
                  {selectedBill?.discount_apply_by?.name || "-"}
                </Descriptions.Item> */}
                <Descriptions.Item label="Approved By">
                  {selectedBill?.discount_approved_by?.name || "N/A"}
                </Descriptions.Item>
              </Descriptions>

              {/* Timeline */}
              <div style={{ marginTop: 16 }}>
                <Spin spinning={logsLoading}>
                  <Timeline>
                    {discountLogs.map((log, index) => (
                      <Timeline.Item
                        key={index}
                        color={
                          log.action === "approved"
                            ? "green"
                            : log.action === "rejected"
                              ? "red"
                              : "orange"
                        }
                      >
                        <b>{log.action.toUpperCase()}</b> — {CURRENCY}{" "}
                        {log.discount_amount || "-"} <br />
                        By: {log.action_by?.name} (
                        {log.action_by?.user_type.toUpperCase()}) <br />
                        {log.remark && (
                          <>
                            Remark: {log.remark} <br />
                          </>
                        )}
                        {dayjs(log.created_at).format("DD-MM-YYYY hh:mm A")}
                      </Timeline.Item>
                    ))}
                  </Timeline>
                </Spin>
              </div>
            </Card>
          </div>
        )}
      </Modal>

      <Modal
        title="Bill Transactions"
        open={txnModalVisible}
        onCancel={closeTxnModal}
        footer={[
          <Button key="close" type="primary" onClick={closeTxnModal}>
            Close
          </Button>,
        ]}
        width={900}
      >
        <Table
          columns={txnColumns}
          dataSource={selectedTransactions}
          rowKey="id"
          pagination={{ pageSize: 5 }}
        />
      </Modal>

      <Modal
        title="Raise Discount Request"
        open={discountModalVisible}
        onCancel={() => setDiscountModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setDiscountModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleRaiseDiscount}>
            Submit
          </Button>,
        ]}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Input
            placeholder="Enter Discount Code"
            value={discountCode}
            onChange={(e) => setDiscountCode(e.target.value)}
          />

          <Input.TextArea
            placeholder="Remark (optional)"
            value={discountRemark}
            onChange={(e) => setDiscountRemark(e.target.value)}
          />
        </Space>
      </Modal>

      <Modal
        title="Reject Discount"
        open={rejectModalVisible}
        onCancel={() => setRejectModalVisible(false)}
        onOk={() => {
          handleDiscountAction("reject", rejectReason);
          setRejectModalVisible(false);
          setRejectReason("");
        }}
      >
        <Input.TextArea
          placeholder="Enter rejection reason"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
        />
      </Modal>

      <LayoutFooter />
    </Layout>
  );
}

export default VendorBills;
